// Easy-to-edit configuration file for J S Kuber website
export const config = {
  // Business Information
  business: {
    name: "JS Kuber",
    legalName: "JS Kuber",
    ownerName: "Jogindra Singh",
    yearEstablished: 2018,
    gstin: "06DKUPS1307D1Z3",
    contact: "9818468519",
    whatsapp: "9818468519",
    email: "jogindrasingh08@gmail.com",
    address: "Unique Medical Devices, Off. No. 11, Basement, New Gurgaon Plaza Market, Opposite Sector-14 (ICICI Bank), Delhi Rd, Gurugram, Haryana 122007",
    mapLocation: {
      lat: 28.4712,
      lng: 77.0803,
      placeId: "ChIJN1t_tDeuDDkRz0qJ0g9J7wM" // Approximate coordinates for Sector 14, Gurugram
    },
    workingHours: "10am to 8pm",
    serviceAreas: ["Gurugram", "Delhi"],
    primaryCity: "Gurgaon",
    homePickup: {
      enabled: true,
      freeRadius: 10, // km
      chargePerKm: 30 // ₹ per km beyond free radius
    },
    paymentMethods: ["Cash", "NEFT", "UPI"],
    branches: 1,
    yearsInBusiness: 8,
    customerCount: 2000,
    certifications: true
  },

  // Hero Banner Images (Easy to change)
  banners: {
    hero: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=1200",
    service1: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=800",
    service2: "https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=800",
    service3: "https://images.unsplash.com/photo-1603561596112-67d13b9c1a0e?w=800",
    service4: "https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=800"
  },

  // Services
  services: [
    {
      id: 1,
      icon: "🏆",
      name: "Sell Gold",
      description: "Sell your gold jewellery at premium rates. Non-destructive testing with certified equipment."
    },
    {
      id: 2,
      icon: "🪙",
      name: "Sell Silver",
      description: "Get best prices for your silver items. Instant payment via cash, UPI or bank transfer."
    },
    {
      id: 3,
      icon: "🔓",
      name: "Buy Mortgaged Gold",
      description: "We buy gold that has been kept in mortgage/pawn. We help release and purchase your mortgaged gold jewellery at best rates."
    }
  ],

  // Features
  features: [
    {
      icon: "🔓",
      title: "Buy Mortgaged Gold",
      subtitle: "We buy gold kept in mortgage/pawn. We help release and purchase your mortgaged jewellery at best rates."
    },
    {
      icon: "🏠",
      title: "Free Home Pickup",
      subtitle: "Free pickup within 10km radius. Charges apply beyond."
    },
    {
      icon: "⚡",
      title: "Instant Cash",
      subtitle: "Get paid immediately - cash, UPI, or bank transfer."
    },
    {
      icon: "🔬",
      title: "Certified Testing",
      subtitle: "Non-destructive testing with certified machines."
    },
    {
      icon: "💰",
      title: "Best Rates",
      subtitle: "Competitive rates above market price for your gold & silver."
    }
  ],

  // Process Steps
  processSteps: [
    {
      number: 1,
      title: "Contact Us",
      description: "Call, WhatsApp or visit our shop. No appointment needed."
    },
    {
      number: 2,
      title: "Free Pickup",
      description: "We come to your location (free within 20km)."
    },
    {
      number: 3,
      title: "Evaluation",
      description: "Transparent testing in front of you with certified equipment."
    },
    {
      number: 4,
      title: "Get Paid",
      description: "Instant cash or bank transfer. Deal done in minutes."
    }
  ],

  // Reviews
  reviews: [
    {
      id: 1,
      name: "Rajesh Kumar",
      rating: 5,
      text: "Excellent service! They came to my home and gave me the best rate for my gold. Highly recommended.",
      location: "Gurugram"
    },
    {
      id: 2,
      name: "Priya Sharma",
      rating: 5,
      text: "Very professional and honest. Got instant cash for my silver items. Will definitely use again.",
      location: "Delhi"
    },
    {
      id: 3,
      name: "Amit Singh",
      rating: 5,
      text: "Best rates in the market. The home pickup service is very convenient. Great experience!",
      location: "Delhi"
    },
    {
      id: 4,
      name: "Sunita Devi",
      rating: 5,
      text: "Trustworthy and reliable. They evaluated my jewellery properly and paid immediately.",
      location: "Gurugram"
    }
  ],

  // Stats
  stats: {
    yearsExperience: "8+",
    happyClients: "2K+",
    branches: "1"
  }
};
